import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useQuery from 'hooks/useQuery'
import validateLogin from 'schemas/login'
import userStorage from 'services/userStorage'
import LoginForm from './LoginForm'

function LoginFormContainer() {
  const [errorStatus, setErrorStatus] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const navigate = useNavigate()

  const { makeRequest } = useQuery({
    defaultMethod: 'post',
    isControlled: true,
    toastOptions: { showFeedbackMessage: false },
    disableAutoLogoutOn401: true,
  })

  const initialValues = {
    email: userStorage.getUser()?.email,
    password: '',
  }

  const onSubmitForm = async (values, role) => {
    setIsSubmitting(true)
    const response = await makeRequest({
      body: {
        email: values.email,
        password: values.password,
      },
      endpoint: `/login/${role.mainPath}`,
    })
    if (response.error) {
      setErrorStatus(response.code)
      setErrorMessage(response.message)
      setIsSubmitting(false)
      return
    }
    userStorage.saveUser(response.data)
    navigate(`/${role.mainPath}`)
  }

  return (
    <LoginForm
      initialValues={initialValues}
      validationSchema={validateLogin}
      onSubmitForm={onSubmitForm}
      error={errorStatus}
      errorMessage={errorMessage}
      isSubmitting={isSubmitting}
    />
  )
}

export default LoginFormContainer
